module.exports = __webpack_public_path__ + "img/worldnet3.a080e638.png";